import a from "rbush";
import l from "@turf/boolean-point-in-polygon";
import { computeBbox as y } from "@allmaps/stdlib";
const I = !0;
class u {
  rbush = new a();
  polygonsById = /* @__PURE__ */ new Map();
  bboxesById = /* @__PURE__ */ new Map();
  itemsById = /* @__PURE__ */ new Map();
  addItem(e, s) {
    this.removeItem(e);
    const t = y(s), r = {
      minX: t[0],
      minY: t[1],
      maxX: t[2],
      maxY: t[3],
      id: e
    };
    this.polygonsById.set(e, s), this.bboxesById.set(e, t), this.itemsById.set(e, r), this.rbush.insert(r);
  }
  removeItem(e) {
    const s = this.itemsById.get(e);
    s && (this.rbush.remove(s), this.polygonsById.delete(e), this.bboxesById.delete(e), this.itemsById.delete(e));
  }
  clear() {
    this.polygonsById.clear(), this.bboxesById.clear(), this.itemsById.clear(), this.rbush.clear();
  }
  search(e, s, t, r) {
    return this.rbush.search({
      minX: e,
      minY: s,
      maxX: t,
      maxY: r
    });
  }
  getBbox(e) {
    return this.bboxesById.get(e);
  }
  getPolygon(e) {
    return this.polygonsById.get(e);
  }
  searchFromBbox(e) {
    const [s, t, r, m] = e;
    return this.search(s, t, r, m).map((i) => i.id);
  }
  searchFromPoint(e, s = I) {
    const [t, r, m, i] = [e[0], e[1], e[0], e[1]], n = this.search(t, r, m, i);
    return s ? n.filter((o) => {
      const h = this.polygonsById.get(o.id);
      return h ? l(e, h) : !1;
    }).map((o) => o.id) : n.map((o) => o.id);
  }
}
export {
  u as default
};
//# sourceMappingURL=RTree.js.map
